import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0",
  y: "0",
  viewBox: "0 0 77.41 66.48",
  style: {"enable-background":"new 0 0 77.41 66.48"},
  "xml:space": "preserve"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        class: "logo-optovision-image_svg__st0",
        d: "M34.55 44.77c0 8.21 1.5 15.44 4.48 21.71L77.41.01c-.17 0-.33-.01-.5-.01Q58.415 0 46.49 12.33c-7.96 8.22-11.94 19.04-11.94 32.44"
      }),
      _createElementVNode("path", {
        class: "logo-optovision-image_svg__st0",
        d: "M33.7 0H0l16.39 28.38c1.34-5.24 3.35-10.15 6.06-14.75C25.51 8.43 29.28 3.9 33.7 0"
      })
    ], -1)
  ])))
}
export default { render: render }